<template>
    <brick-circle-base
        class="journey-brick"
        :class="[isActive ? 'active' : 'undefined', brickTypeName]"
        @mouseup.left="openSettings(tabs.generalSettings)"
    >  
        <div class="sub settings" @mouseup.left="openSettings(tabs.generalSettings)"
            :class="[isActive ? 'active' : 'undefined', brickTypeName]"
        >
            <i class="fas fa-cog"></i>
            <a class="title">{{resource('JourneyBuilder_JourneyBrickMenu_Settings_DisplayName')}}</a>
        </div>

        <div class="sub deduplicate" @mouseup.left="openSettings(tabs.deduplicationSettings)"
            :class="[isDeduplicationActive ? 'active' : 'undefined']"
        >
            <i class="fas fa-clone"></i>
            <a class="title">{{resource('JourneyBuilder_JourneyBrickMenu_Deduplicate_DisplayName')}}</a>
        </div>

        <div class="sub delay" @mouseup.left="openSettings(tabs.generalSettings)"
            :class="[isDelayed ? 'active' : 'undefined']"
        >
            <i class="fas fa-clock"></i>
            <a class="title">{{resource('JourneyBuilder_JourneyBrickMenu_Delay_DisplayName')}}</a>
        </div>
        
        <div class="brick-icon" >
            <i class="fas fa-magic" />
        </div>
    
        <journey-connection-settings ref="settings"
            :connection="connection"
            :available-conditions="config.availableConditions"

            @closed="settingsOpen = false"

            @save="$emit('change-connection', $event)"
            @delete="$emit('delete-connection', $event)"
        />
    </brick-circle-base>
</template>

<script>
    import resources from '../../../../Util/Mixins/resources';
    import snowplow from "../../snowplow";
    
    import journeyBrickMixin from '../../Mixins/journey-brick'
    import permissionsMixin from '../../Mixins/journey-permissions';

    import BrickCircleBase from "./../BrickCircleBase.vue";
    import {default as JourneyConnectionSettings, tabs} from './JourneyConnection/JourneyConnectionSettings.vue';
    
    export default {
        name: 'journey-brick-circle',
        components: {
            BrickCircleBase,
            JourneyConnectionSettings
        },
        mixins: [journeyBrickMixin, permissionsMixin, resources],
        created() {
            this.cords = this.currentCords;
        },
        methods: {
            openSettings(tab) {
                if(this.settingsOpen){
                    return;
                }

                this.settingsOpen = true;

                snowplow.trackStructuredEvent('open-connection-settings');
                const vm = this;

                //Settings should not be shown when the user cannot write
                if(!vm.canWrite){
                    return;
                }
                
                // We need to allow for some time for the coordinates to be updated.
                // Unfortunately, nextTick did not do the t(r)ick
                setTimeout(() => {
                    if (!vm.wasDragged) {
                        vm.$refs.settings.show(tab);
                    } else {
                        this.settingsOpen = false;
                        vm.cords = vm.currentCords;
                    }
                }, 0)
            }
        },
        computed: {
            wasDragged() {
                return this.cords.x !== this.x || this.cords.y !== this.y;
            }, 
            currentCords() {
                return { x: this.x, y: this.y }
            },
            isDelayed() {
                return this.connection.config.delay.unit && this.connection.config.delay.seconds > 0;
            }
        },
        data() {
            return {
                settingsOpen: false,
                cords: {},
                tabs
            };
        },
        props: {
            connection: {
                type: Object,
                required: true
            },
            isDeduplicationActive: {
                type: Boolean,
                required: true
            }
        }
    }
</script>

<style scoped src="../../Style/journey-brick-circle.scss" lang="scss">
</style>